// src/utils/eventEmitter.js
const subscribers = new Set();

export const globalEventEmitter = {
  subscribe: fn => {
    subscribers.add(fn);
    return () => subscribers.delete(fn);
  },
  emit: payload => {
    for (const fn of subscribers) {
      try {
        fn(payload);
      } catch (e) {
        // ignore listener errors
        // console.error("Emitter listener error", e);
      }
    }
  },
};
